import { useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import styles from '@/components/directory/v2/DirectoryFilters.module.css'
import RangeFilter from '@/components/filters/RangeFilter'
import BadgeManager from '@/components/filters/v2/BadgeManager'
import BodyStyleFilter from '@/components/filters/BodyStyleFilter'
import SeatsFilter from '@/components/filters/SeatsFilter'
import PriceFilter from '@/components/filters/PriceFilter'

const filters = ['make', 'model', 'range', 'body_style', 'seats', 'price']

const DirectoryFilters = ({ total, searchTerm }) => {
  const [prevTotal, setPrevTotal] = useState(0)
  const [currentTotal, setCurrentTotal] = useState(total)
  const router = useRouter()

  useEffect(() => {
    setPrevTotal(currentTotal)
    setCurrentTotal(total)
  }, [total])

  const onBadgeRemove = (filterIndex) => {
    const { [filterIndex]: _, ...rest } = router.query

    router.push({
      pathname: router.pathname,
      query: rest,
    })
  }

  return (
    <div className={styles.directory_filters__container}>
      <div className={styles.directory_filters__filters}>
        <RangeFilter />
        <BodyStyleFilter />
        {/*<PriceFilter />*/}
        <SeatsFilter />
      </div>
      <div className={styles.directory_filters__badges}>
        <BadgeManager onBadgeRemove={onBadgeRemove} filters={filters} />
      </div>
    </div>
  )
}

export default DirectoryFilters
